import { AppDispatch } from '@/domain/store';
import { createAppAsyncThunk } from '@/domain/store.thunk';

import {
  TourTravel,
  TourTravelConnexionTypeWithEvent,
} from '../entities/project-tour-ontour-travel.entity';
import { addTourTravel, AddTourTravelParams } from './add-tour-travel.action';
import { calculateDirectTravelDistanceAndEditTourTravel } from './calculate-direct-travel-distance-and-edit-tour-travel.action';

type Params = {
  sequenceId: number;
  connexionType: TourTravelConnexionTypeWithEvent;
  fromTourEventId: number;
  toTourEventId: number;
};

type Result = void;

export const prepareAndAddTourTravel = createAppAsyncThunk(
  'projectTourOntour/prepareAndAddTourTravel',
  async (params: Params, { dispatch }): Promise<Result> => {
    const paramsAdd = await prepareAddTourTravelParams(params);
    const createdTourTravel = await dispatch(addTourTravel(paramsAdd)).unwrap();
    dispatchCalculateDistanceForDirect(dispatch, createdTourTravel);
  },
);

async function dispatchCalculateDistanceForDirect(
  dispatch: AppDispatch,
  tourTravel: TourTravel,
) {
  if (tourTravel.connexionTypeWithEvent === 'direct') {
    dispatch(
      calculateDirectTravelDistanceAndEditTourTravel({
        tourTravel: tourTravel,
      }),
    );
  }
}

async function prepareAddTourTravelParams(params: Params) {
  let paramsAddTour: AddTourTravelParams;
  switch (params.connexionType) {
    case 'incoming':
      paramsAddTour = await prepareAddTourTravelParams_incoming(params);
      break;
    case 'direct':
      paramsAddTour = await prepareAddTourTravelParams_direct(params);
      break;
    case 'outgoing':
      paramsAddTour = await prepareAddTourTravelParams_outgoing(params);
      break;
  }
  return paramsAddTour;
}

async function prepareAddTourTravelParams_incoming(params: Params) {
  const paramsAddTour: AddTourTravelParams = {
    sequenceId: params.sequenceId,
    tourTravel: {
      name: '',
      connexionTypeWithEvent: params.connexionType,
      travelDistance: 0,
      fromEventId: undefined,
      fromPosition: undefined,
      toEventId: params.toTourEventId,
      toPosition: undefined,
    },
  };

  return paramsAddTour;
}

async function prepareAddTourTravelParams_direct(params: Params) {
  const paramsAddTour: AddTourTravelParams = {
    sequenceId: params.sequenceId,
    tourTravel: {
      name: '',
      connexionTypeWithEvent: params.connexionType,
      travelDistance: 0,
      fromEventId: params.fromTourEventId,
      fromPosition: undefined,
      toEventId: params.toTourEventId,
      toPosition: undefined,
    },
  };
  return paramsAddTour;
}

async function prepareAddTourTravelParams_outgoing(params: Params) {
  const paramsAddTour: AddTourTravelParams = {
    sequenceId: params.sequenceId,
    tourTravel: {
      name: '',
      connexionTypeWithEvent: params.connexionType,
      travelDistance: 0,
      fromEventId: params.fromTourEventId,
      fromPosition: undefined,
      toEventId: undefined,
      toPosition: undefined,
    },
  };
  return paramsAddTour;
}
